module.exports = __webpack_public_path__ + "static/media/undraw_not_found_60pq.18ba7de5.svg";